export default __webpack_public_path__ + "static/media/bike-11.cc2273f0.png";